<template>
  <div>
    <vxe-grid
      ref="stockTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="budGetTableData"
      :columns="tableColumns"
      resizable
      size="mini"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './stock-detail-table'
import { format } from '@/libs/util.number.js'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  watch: {
    tableData: {
      handler() {
        const tempData = this.tableData || []
        this.budGetTableData = [...tempData]
      },
      immediate: false,
      deep: true,
    },
  },
  mounted() {
    this.budGetTableData = [...this.tableData]
  },
  data() {
    return {
      budGetTableData: [{}],
      categoryTree: [],
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      editRules: {
      },
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.stockTable.getTableData()
      return fullData
    },
    push(row) {
      this.budGetTableData.push(row)
      this.$emit('updateTableData', this.budGetTableData)
    },
    del(row) {
      this.$refs.stockTable.remove(row)
      this.budGetTableData = this.budGetTableData.filter(
        (item) => item._X_ID != row._X_ID
      )
      this.$emit('updateTableData', this.budGetTableData)
    },
  },
}
</script>
